import { render, staticRenderFns } from "./QuotaPolicy.vue?vue&type=template&id=de1de8ee&scoped=true"
import script from "./QuotaPolicy.vue?vue&type=script&lang=js"
export * from "./QuotaPolicy.vue?vue&type=script&lang=js"
import style0 from "./QuotaPolicy.vue?vue&type=style&index=0&id=de1de8ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1de8ee",
  null
  
)

export default component.exports